<template>
  <div class="content-wrapper">
  	<div class="wrapper-padding-bottom">
      <div data-type="layout" class="span-full span-full-bg bgblue relative" style="background-image:url('/static/images/home-bg.png'); ">
        <a href="#" data-index="0" class="read-more">
          <span class="arrow-down"></span>
        </a>
      </div>

      <div data-type="layout" id="say-no" v-if="first.title" data-header="green" class="span-full bgwhite">
	  		<div class="table-wrap">
          <div class="table-cell">
    				<h2 class="green">{{first.title}}</h2>
    				<div class="content-960 black mt3">
  	  				<h3 v-html="first.content"></h3>
              <div class="full-btn">
  	  				 <a v-if="first.link_title" v-bind:href="first.link_url" class="btn btn-green mt3">{{first.link_title}}</a> 
              </div>
    				</div>
          </div>
  			</div>
        <a href="#" data-index="1" class="read-more green">
          <span class="arrow-down"></span>
        </a>
	  	</div>

      <div data-type="layout">
    		<swiper v-if="blue_slider.title" :options="swiperOption" ref="blueSwiper" class="span-swiper span-swiper-full span-full full-transitions bgblue">
  	      <swiper-slide>
  	      	<div class="full-inner">
              <h2 class="white" v-html="blue_slider.title"></h2>
  	      	</div>
  	      </swiper-slide>
  	      <swiper-slide>
  	      	<div class="full-inner">
        			<h3 class="white no-br content-500" v-html="blue_slider.title"></h3>
        			<div class="entry-content pt3 content-750" v-html="blue_slider.content"></div>
              <div class="full-btn">
  						  <a v-if="blue_slider.link_title" v-bind:href="blue_slider.link_url" class="btn btn-white mt3">{{blue_slider.link_title}}</a>
              </div>
        	  </div>
  	      </swiper-slide>
  	      <div class="swiper-button-prev" slot="button-prev"></div>
  	      <div class="swiper-button-next" slot="button-next"></div>
  	    </swiper>
        <a href="#" data-index="2" class="read-more">
          <span class="arrow-down"></span>
        </a>
      </div>

      <div data-type="layout">
  	    <swiper v-bind:id="'green-swiper'" v-if="green_slider.title" :options="swiperOption" ref="greenSwiper" class="span-swiper span-swiper-full span-full full-transitions bggreen">
  	      <swiper-slide>
  	      	<div class="full-inner">
  		      	<h2 class="white" v-html="green_slider.title"></h2>
  	      	</div>
  	      </swiper-slide>
  	      <swiper-slide>
  	      	<div class="full-inner">
        			<h3 class="white no-br" v-html="green_slider.title"></h3>
        			<div class="entry-content pt3 content-750" v-html="green_slider.content"></div>
              <div class="full-btn">
               <a v-if="green_slider.link_title" v-bind:href="green_slider.link_url" class="btn btn-white mt3">{{green_slider.link_title}}</a>
              </div>
  	      	</div>
  	      </swiper-slide>
  	      <div class="swiper-button-prev" slot="button-prev"></div>
  	      <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
        <transition name="error-fade">
          <a v-show="greenActive === 1" class="full-bottom-logo" target="_blank" href="//www.plasticpollutioncoalition.org/">
            <img src="/static/images/footer-credits-naturaplastickill-2.png" alt="">
          </a>
        </transition>
        <a href="#" data-index="3" class="read-more">
          <span class="arrow-down"></span>
        </a>
      </div>

  	</div>
  	<footer-app></footer-app>
  </div>
</template>

<script>
import FooterApp from './Footer'
import misc from '../js/scripts.js'
export default {
  name: 'Index',
  components: {
  	FooterApp
  },
  data() {
    return {
      title: {
        en: 'A Campaign by Natura and PPC',
        es: 'Una Campaña de Natura y PPC'
      },
      description: {
        en: 'Plastic Kills is a campaign by Natura and Plastic Pollution Coalition to raise awareness about plastic pollution. Learn how to say NO to single-use plastic!',
        es: 'Plastic Kills es una campaña de Natura y Plastic Pollution Coalition para concienciar sobre la polución plástica. Aprende a decir NO al plástico desechable.'
      },
      showArrow: true,
      first: {},
      observer: false,
      blue_slider: {},
      green_slider: {},
      greenActive: 0,
      swiperOption: {
        notNextTick: true,
        loop:true,
        updateTranslate: true,
        direction : 'horizontal',
        prevButton:'.swiper-button-prev',
        nextButton:'.swiper-button-next',
        observeParents:true,
        debugger: true,
        speed: 600,
        autoplay: 0,
        paginationClickable :false,
        onSlideChangeStart(s){
          if( misc.isTouch() ){
            var activeSlideHeight = s.slides[s.activeIndex].querySelector('.full-inner').getBoundingClientRect().height + 'px';
            s.container[0].style.height = activeSlideHeight
            if( misc.get_viewport().width > 560 ){
              s.container[0].style.minHeight = '100vh'
            }
          }
        }
      }
    }
  },
  head: {
    title() {
      return {
        inner: this.title[localStorage.getItem('language')]
      }
    },
    meta() {
      return [
        { name: 'description', content: 'Descripcion de Soluciones' },
        { name: 'twitter:title', content: this.title[localStorage.getItem('language')] },
        { name: 'twitter:descripcion', content: this.description[localStorage.getItem('language')] },
      ]
    },
    link() {
      return [
        { rel: 'canonical', href: window.location.href },
      ]
    }
  },
  computed: {
    blueSwiper() {
      return this.$refs.blueSwiper.swiper
    },
    greenSwiper() {
      return this.$refs.greenSwiper.swiper
    },
  },
  methods: {
    getUrl(){
      if( localStorage.getItem('language') === 'en' ){
        return process.env.site.url + '/wp-json/wp/v2/pages?slug=home-page'
      } else {
        return process.env.site.url + '/wp-json/wp/v2/pages?slug=pagina-de-inicio&lang=es'
      }
    },
    loadContent(){

      var getUrl = this.getUrl()

      this.axios.request({ 
        method: 'GET',
        url: this.getUrl(),
      }).then((response) => {
        var page = response.data[0]
        this.first = {
          title: page.acf.first_home_title,
          content: page.acf.first_home_content,
          link_title: page.acf.first_home_link,
          link_url: page.acf.first_home_link_url
        }
        this.blue_slider = {
          title: page.acf.blue_title,
          content: page.acf.blue_content,
          link_title: page.acf.blue_link_content,
          link_url: page.acf.blue_link_url
        }
        this.green_slider = {
          title: page.acf.green_title,
          content: page.acf.green_content,
          link_title: page.acf.green_link,
          link_url: page.acf.green_link_url
        }
        this.$nextTick( () => {
          this.observeGreen()
          misc.addArrows()
        })
      })
    },
    observeGreen(){
      // console.log(this.$refs.greenSwiper.swiper)
      if( this.$refs.greenSwiper === undefined || this.$refs.greenSwiper.swiper === undefined ){
        console.log('exiting')
        return false
      }

      var green = this.$refs.greenSwiper.swiper.container[0].querySelector('.swiper-wrapper')
      this.observer = new MutationObserver( mutations => {
        mutations.forEach( mutation => {
          if(mutation.attributeName === 'style'){
            this.greenActive = this.$refs.greenSwiper.swiper.realIndex
          }
        });
      });
      this.observer.observe(green,  {
          attributes: true
      });
    },
    scrollContent(){
      const offset = 60
      document.querySelectorAll('.wrapper-padding-bottom .span-full').forEach( (item, index) => {
        if( item.getBoundingClientRect().top < offset && item.getBoundingClientRect().bottom > offset )
          if( item.dataset.header )
            document.querySelector('.header-nav').dataset.color = item.dataset.header
          else 
            document.querySelector('.header-nav').dataset.color = 'white'
        if( document.querySelectorAll('.wrapper-padding-bottom .span-full').length === (index + 1) && item.getBoundingClientRect().bottom < 0 ){
          document.querySelector('.header-nav').dataset.color = 'white'
        }
      })
    },
    doArrow(){
      misc.scrollTo2('#say-no', 600);
    },
    reloadContent(){
      this.observer.disconnect()
      this.$nextTick(()=>{
        this.loadContent()
      })
    }
  },
  watch: {
    '$route': 'reloadContent'
  },
  created(){
    this.loadContent()
  },
  mounted(){
    window.addEventListener('scroll', this.scrollContent )
  },
  beforeDestroy(){
    misc.removeArrows()
    window.removeEventListener('scroll', this.scrollContent )
  }
}
</script>


// WEBPACK FOOTER //
// index.vue?8aa44728